export const GA_MEASUREMENT_ID = 'G-RCER9NG7YY';

export const pageview = (url) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};
